import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { s3_img_url } from '../../../Helper/request';

const Rings = ({ add_to_wishlist, data, productdetailapi, klaviyo_Wishlist,kleviyoRemoveWishlist  }) => {

  const [ringData, setringData] = useState(data);

  useEffect(() => {
    setringData(data)
  }, [data, add_to_wishlist])

  var SliderSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: "",
    nextArrow: "",
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 10,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <Slider className="parentSl" {...SliderSettings}>
    {ringData?.map((val, index) => (
      <div className="product_box text-center plr15">
        <div className="product_bg">
          <p className="best_seller d-flex justify-content-between">
            {val?.overlay_top_left?.length ? (
              <span>BEST SELLER</span>
            ) : (
              <b></b>
            )}
            {val.is_wishlist == 0 ? (
              <img
                src={s3_img_url + 'heart.svg'}
                alt="wishlist"
                onClick={() =>{
                  klaviyo_Wishlist(val);
                  add_to_wishlist(val.group_id, val.product_id, index)
                }}
              />
            ) : (
              <img
                src={s3_img_url + 'heart-fill.svg'}
                alt="WishList"
                onClick={() =>{
                  kleviyoRemoveWishlist(val);
                  add_to_wishlist(val.group_id, val.product_id, index)
                }}
              />

            )}
          </p>
          <Link
            to={'/product-detail/' + val?.group_id + '/' + val?.slug}
            onClick={() => productdetailapi(val.group_id, val.slug)}
          >
            {' '}
            <img className="Pro_img" src={val?.product_image[0]?.url} alt={val?.name} />
          </Link>
        </div>
        <Link to={'/product-detail/' + val?.group_id + '/' + val?.slug}>
          <h3 className="pro_name">{val?.name}</h3>
        </Link>
        <h4 className="pro_price">
          {val?.currency}
          {val?.price}
        </h4>
      </div>
    ))}
  </Slider>
  );
};

export default Rings;
